<template>
  <div>
    <v-simple-table class="custom-table">
      <template v-slot:default>
        <thead>
        <tr>
          <th style="width: 100%; font-size: large">Document</th>
          <th style="width: 100%; font-size: large">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="document in driverDocuments" :key="document.id">
          <td>{{ document.description }}</td>
          <td>
            <v-btn @click="viewDocument(document)" small>View Document</v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>

import axios from "axios";
import AttributesForTaxiCell from "@/components/widget/AttributesForTaxiCell.vue";
import FileInput from "@/components/widget/input/FileInput.vue";

axios.defaults.withCredentials = true;

export default {
  name: "driver_signup_documents_list",
  components: {
    AttributesForTaxiCell,
    FileInput,
  },
  props: {
    driverDocuments: {
      type: Array,
      default: []
    }
  },
  watch: {
    driverDocuments() {
      this.$forceUpdate()
    }
  },
  data: function () {
    return {
      query: Object,
      driverDoc: Object,
      uploadedFile: {},
      fetchedDriverDocument: null,
      selectedItem: null,
      viewFileDialog: false,
      fileUploadDialog: false,
      currentDocType: null,
      headers: [
        {
          text: "Document",
          align: "left",
          sortable: false,
          value: "document",
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
        },
      ]
    };
  },
  mounted: async function () {
    console.log("MOUNTED");
  },
  methods: {
    refresh() {
    },
    viewDocument: async function (ddu) {
      this.viewFileDialog = true;

      this.fetchedDriverDocument = ddu;
      this.uploadedFile = null;

      const link = document.createElement("a");
      link.href = this.fetchedDriverDocument.url;
      link.target = "_blank";
      link.setAttribute("download", this.fetchedDriverDocument.filename);
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}

.fixed-booking-table-row {
  overflow: hidden;
  height: 18px;
}

.table-row {
  width: 100%;
  padding: 16px;
}

.custom-table {
  padding: 10px;
}

</style>
